"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOfferItem = updateOfferItem;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _deleteOfferItem = require("./deleteOfferItem");
async function updateOfferItem(params) {
  const {
    client,
    itemCode,
    offerId,
    quantity,
    sessionId,
    tenant
  } = params;
  if (quantity === 0) {
    return (0, _deleteOfferItem.deleteOfferItem)(params);
  }
  const globalShoppingOfferChoiceDtoBody = {
    itemCode,
    quantity
  };

  // TODO -- Is this needed when there is the tenant prop of ApiProvider applied on some upper level?
  const headers = {
    [_fetching.TENANT_CONTEXT]: tenant
  };
  return (0, _globalApiClientReact.updateShoppingSessionOfferChoice)(client, sessionId, offerId, itemCode, globalShoppingOfferChoiceDtoBody, headers);
}